import GetShopRegions from "../symbols/getShopRegions";
import { HttpRequestGet } from "../../service";

const getShopRegionsAction = () => ({
  type: GetShopRegions.GET_SHOP_REGIONS,
});
const getShopRegionsSuccessAction = (data: any) => {
  return {
    type: GetShopRegions.GET_SHOP_REGIONS_SUCCESS,
    payload: data,
  };
};
const getShopRegionsFailureAction = (data: any) => ({
  type: GetShopRegions.GET_SHOP_REGIONS_FAILURE,
  payload: {
    data,
  },
});
const clearShopRegionsAction = () => ({
  type: GetShopRegions.CLEAR_SHOP_REGIONS,
});

export function getShopRegions() {
  return (dispatch: any) => {
    dispatch(getShopRegionsAction());
    HttpRequestGet(
      `/merchant/region`,
      dispatch,
      getShopRegionsSuccessAction,
      getShopRegionsFailureAction,
      true,
      () => {}
    );
  };
}
export function clearShopRegions() {
  return (dispatch: any) => {
    dispatch(clearShopRegionsAction());
  };
}
